var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgFindCampaign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6981_95356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9795 79.9999C58.9131 79.9999 75.8843 62.8192 75.8843 41.5515C75.8843 20.2837 58.8383 3.10303 37.9795 3.10303C17.0459 3.10303 0.074707 20.2837 0.074707 41.5515C0.074707 62.8192 17.0459 79.9999 37.9795 79.9999Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4172 16.3478C75.1101 16.3478 76.4825 14.9585 76.4825 13.2447C76.4825 11.5309 75.1101 10.1416 73.4172 10.1416C71.7243 10.1416 70.3519 11.5309 70.3519 13.2447C70.3519 14.9585 71.7243 16.3478 73.4172 16.3478Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9029 4.23841C79.0591 4.23841 79.9963 3.28961 79.9963 2.1192C79.9963 0.9488 79.0591 0 77.9029 0C76.7468 0 75.8096 0.9488 75.8096 2.1192C75.8096 3.28961 76.7468 4.23841 77.9029 4.23841Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09336 16.2726C3.24949 16.2726 4.18672 15.3238 4.18672 14.1534C4.18672 12.983 3.24949 12.0342 2.09336 12.0342C0.937229 12.0342 0 12.983 0 14.1534C0 15.3238 0.937229 16.2726 2.09336 16.2726Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6981_95356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7727 22.3277L64.3709 71.0694C64.3709 72.7344 63.0251 74.0211 61.3803 74.0211H14.4292C12.7845 74.0211 11.4387 72.6588 11.4387 71.0694V8.40146C11.4387 6.73637 12.7845 5.44971 14.4292 5.44971H48.4464L63.7727 22.3277Z",
    fill: "url(#paint0_linear_6981_95356)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.3162 64.2579H32.5967C32.2229 64.2579 31.9238 63.8794 31.9238 63.4253C31.9238 62.9712 32.2229 62.5928 32.5967 62.5928H34.3162C34.6901 62.5928 34.9891 62.9712 34.9891 63.4253C34.9891 63.9551 34.6901 64.2579 34.3162 64.2579Z",
    fill: "#CED7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0828 64.2579H19.0646C18.6908 64.2579 18.3917 63.8794 18.3917 63.4253C18.3917 62.9712 18.6908 62.5928 19.0646 62.5928H29.0828C29.4566 62.5928 29.7557 62.9712 29.7557 63.4253C29.7557 63.9551 29.4566 64.2579 29.0828 64.2579Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8673 15.6671H19.3636C18.8403 15.6671 18.3917 15.2129 18.3917 14.6831C18.3917 14.1533 18.8403 13.6992 19.3636 13.6992H41.8673C42.3906 13.6992 42.8392 14.1533 42.8392 14.6831C42.8392 15.2129 42.3906 15.6671 41.8673 15.6671Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0361 21.1163H19.3636C18.8403 21.1163 18.3917 20.6622 18.3917 20.1324C18.3917 19.6026 18.8403 19.1484 19.3636 19.1484H27.9614C28.4847 19.1484 28.9333 19.6026 28.9333 20.1324C28.9333 20.6622 28.4847 21.1163 28.0361 21.1163Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4464 5.44971V18.9218C48.4464 20.8139 50.0912 22.3277 51.9603 22.3277H63.7728",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3614 75.1564C66.6138 75.1564 65.8662 74.8537 65.2681 74.1725L52.7827 61.533L52.3341 61.8357C48.2969 64.8631 43.5868 66.4526 38.802 66.4526C33.0453 66.4526 27.2885 64.1063 23.027 60.0193C18.5413 55.7052 16.0741 49.8773 16.0741 43.5197C16.0741 30.8802 26.2419 20.5869 38.7273 20.5869C47.2502 20.5869 54.7265 25.1281 58.7637 32.848C62.7261 40.4923 62.2028 49.4232 57.3432 56.6134L57.0442 57.0675L69.6043 69.7827C70.8753 71.0694 70.5762 72.3561 70.352 73.0372C69.7539 74.2482 68.5576 75.1564 67.3614 75.1564ZM38.7273 26.8688C29.6062 26.8688 22.2794 34.3617 22.2794 43.5197C22.2794 53.9644 30.7276 60.2463 38.9515 60.2463C43.9607 60.2463 48.5212 57.9757 51.736 53.8887C55.6984 48.8934 56.3713 42.1574 53.6051 36.3296C50.7641 30.5018 45.0821 26.8688 38.7273 26.8688Z",
    fill: "#989FB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6981_95356",
    x: -10.5613,
    y: -5.55029,
    width: 96.9321,
    height: 112.571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6981_95356"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6981_95356",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6981_95356",
    x1: 37.8875,
    y1: 3.86359,
    x2: 37.8875,
    y2: 74.7604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6981_95356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgFindCampaign);
export default __webpack_public_path__ + "static/media/svg_find_campaign.1a17837ba42c42e0ed9d00c4a0abde12.svg";
export { ForwardRef as ReactComponent };